import Vue from 'vue'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.menuHistory) this.$menuHistory = options.menuHistory
    else if (options.parent && options.parent.$menuHistory)
      this.$menuHistory = options.parent.$menuHistory
  },
})

const development = process.env.NODE_ENV === 'development'

// TODO 本番でもsessionStorageにする？要検討
const storage = development ? sessionStorage : localStorage

const SAVE_KEY = development ? 'DEV_GIGGLE_MENU_HISTORY' : 'GIGGLE_MENU_HISTORY'
const HISTORY_COUNT = process.env.VUE_APP_MENY_HISTORY_COUNT
  ? Number(process.env.VUE_APP_MENU_HISTORY_COUNT)
  : 15

/**
 * メニューの閲覧履歴を管理するサービス
 */
export default {
  /**
   * メニューを閲覧履歴に追加する
   *
   * 記録できるメニュー数には制限があります。デフォルト15で、VUE_APP_MENU_HISTORY_COUNT
   * の設定値で上書きされます。既に履歴に保存されているメニューを追加指定した場合、既存の履歴
   * から当該メニューは削除されます。
   *
   * @param {String} menuCode 履歴に追加するメニューコード
   */
  add(menuCode) {
    const value = storage.getItem(SAVE_KEY)
    let history = value ? JSON.parse(value) : []

    // 履歴に既に登録されているメニューは重複表示しないため、
    // 削除しておく（追加したいメニューコードを先頭に追加するため
    // 結果的に先頭に移動したことになる）。
    history = history.filter(h => h !== menuCode)

    const added = [menuCode, ...history.slice(0, HISTORY_COUNT - 1)]

    storage.setItem(SAVE_KEY, JSON.stringify(added))

    return Promise.resolve(undefined)
  },
  /**
   * 閲覧履歴を取得する
   *
   * @returns {Array<String>} 閲覧履歴（メニューコード）
   */
  get() {
    const value = storage.getItem(SAVE_KEY)
    const history = value ? JSON.parse(value) : []
    return Promise.resolve(history)
  },
}
